module.exports = __webpack_public_path__ + "img/soundcloud.6e28dd5b.png";